import { useEffect, useState } from 'react';
import { SelectOpt } from '../../common/CommonTypes';
import SelectInput from '../selectInput/SelectInput';
import { states } from 'Constants/Common';
import { useTranslation } from 'react-i18next';

export type USStatesProps = {
    state: string;
    onChangeState: (selectedValue: string) => void;
};

const USStates = ({ state, onChangeState }: USStatesProps): JSX.Element => {
    const [usStates, setUSStates] = useState<SelectOpt[]>([]);

    const { t } = useTranslation();

    useEffect(() => {
        if (!usStates || usStates.length < 1) {
            setUSStates(
                states.optionsdata.map((s) => {
                    return {
                        id: s.key,
                        text: s.value,
                        value: s.key,
                        disabled: false
                    } as SelectOpt;
                })
            );
        }
    }, [usStates]);

    return (
        <SelectInput
            name='location-state'
            className='state-location-select-padding '
            loadingText={t('loading')}
            label={t('select_state')}
            value={state}
            options={usStates}
            onChange={onChangeState}
            forceDefault
            defaultIfOneOption
            addDefaultOption
            defaultText={t('select_default')}
        />
    );
};

export default USStates;
